import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoadingDialogComponent} from "./loading/loading-dialog/loading-dialog.component";
import {ErrorDialogComponent} from "./errors/errors-dialog/errors-dialog.component";
import {LoadingDialogService} from "./loading/loading-dialog.service";
import {ErrorDialogService} from "./errors/errors-dialog/errors-dialog.service";
import {RouterModule} from "@angular/router";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatDialogModule} from "@angular/material/dialog";
import {MatButtonModule} from "@angular/material/button";
import {PopupDialogService} from "./popup/popup-dialog.service";
import {PopupDialogComponent} from "./popup/popup-dialog.component";


@NgModule({
  declarations: [
    ErrorDialogComponent,
    LoadingDialogComponent,
    PopupDialogComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatButtonModule
  ],
  exports: [
    LoadingDialogComponent,
  ],
  providers: [
    ErrorDialogService,
    PopupDialogService,
    LoadingDialogService
  ]
})
export class SharedModule {
}
